import request from "./client";

export const getById = async ({ id }) => {
  const resp = await request.get(`/v1/items/${id}`);
  return { data: resp.body };
};
export const getSome = async ({
  q = "",
  filter = "",
  limit = 10,
  offset = 0,
  sort_by = "number",
  sort_dir = "asc",
}) => {
  try {
    const query = new URLSearchParams({
      limit,
      offset,
      sort_by,
      sort_dir,
      ...(q && { q }),
      ...(filter && { filter }),
    }).toString();
    const resp = await request.get(`/v1/items?${query}`);
    const body = resp.body;
    return { total: body.meta.total, data: body.results, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response.body };
  }
};

export const createOne = async ({
  number,
  name,
  description,
  highlight,
  characteristic,
  inspect_every_x_months,
  group_ids,
}) => {
  try {
    const resp = await request.post("/v1/items").send({
      number,
      name,
      description,
      highlight,
      characteristic,
      inspect_every_x_months,
      group_ids,
    });
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const updateOne = async ({
  id,
  number,
  name,
  description,
  highlight,
  characteristic,
  inspect_every_x_months,
  group_ids,
}) => {
  try {
    const resp = await request.put(`/v1/items/${id}`).send({
      number,
      name,
      description,
      highlight,
      characteristic,
      inspect_every_x_months,
      group_ids,
    });
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};
